import { MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import { useContext } from 'react';
import { TranslationContext } from "../../../context/translations/translations-context";
import useResumeDocumentSection from "../../../hooks/useResumeDocumentSection";
import useResumeProperties from "../../../hooks/useResumeProperties";
import LanguageSkillItem from "./LanguageSkillItem";

export default function LanguageSkillList() {

    const { translations } = useContext( TranslationContext );
    const { isEuropass } = useResumeProperties();
    const { languageSkills } = useResumeDocumentSection();

    return (
        <div className="shadow-4 rounded-5" style={ { overflowX: isEuropass && "auto" } }>
            <MDBTable style={ { fontSize: isEuropass && ".7rem" } }>
                <MDBTableHead>
                    <tr className="text-center text-white bg-gradient">
                        <th></th>
                        <th colSpan="2">{ translations.languageSkillsSection.comprehensionTitle }</th>
                        <th colSpan="2">{ translations.languageSkillsSection.oralExpressionTitle }</th>
                        <th>{ translations.languageSkillsSection.writingExpressionTitle }</th>
                    </tr>
                    <tr className="text-white">
                        <th>{ translations.languageSkillsSection.selectLanguageLabel }</th>
                        <th className="text-center">{ translations.languageSkillsSection.listeningComprehensionTitle }</th>
                        <th className="text-center">{ translations.languageSkillsSection.readingComprehensionTitle }</th>
                        <th className="text-center">{ translations.languageSkillsSection.continuousOralExpressionTitle }</th>
                        <th className="text-center">{ translations.languageSkillsSection.oralInteractionTitle }</th>
                        <th className="text-center"></th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody style={ { verticalAlign: 'middle' } }>
                    { languageSkills
                        ?.sort( ( a, b ) => a.order - b.order )
                        .map( languageSkill => (
                            <LanguageSkillItem
                                key={ languageSkill.order }
                                item={ languageSkill }
                                numberOfItems={ languageSkills.length }
                            />
                        ) ) }
                </MDBTableBody>
            </MDBTable>
        </div>
    );
}
